document.querySelectorAll('[data-chat-demo]').forEach((demo) => {
  const tabs = [...demo.querySelectorAll('[role="tab"]')]
  const panels = [...demo.querySelectorAll('[data-chat-scenario]')]
  const panes = [...demo.querySelectorAll('[data-chat-pane]')]
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)')
  const timers = new Map()
  const originals = new Map()
  let observer
  let selected = 0

  const later = (pane, callback, delay) => {
    const id = window.setTimeout(callback, delay)
    timers.get(pane).push(id)
  }
  const reset = (pane) => {
    observer?.unobserve(pane)
    ;(timers.get(pane) || []).forEach(clearTimeout)
    timers.set(pane, [])
    pane.classList.remove('is-animating')
    pane.querySelectorAll('[data-chat-step]').forEach((step) => {
      step.classList.remove('is-visible', 'is-pending')
      if (originals.has(step)) step.textContent = originals.get(step)
    })
  }
  const play = (pane) => {
    observer.unobserve(pane)
    let delay = 150
    pane.querySelectorAll('[data-chat-step]').forEach((step) => {
      const start = delay
      later(pane, () => {
        step.classList.add('is-visible')
        if (step.matches('.chat-msg-user')) {
          const text = originals.get(step)
          step.textContent = ''
          Array.from(text).forEach((_, index) => later(pane, () => {
            step.textContent = Array.from(text).slice(0, index + 1).join('')
          }, index * 12))
        } else if (step.matches('.chat-step')) {
          step.classList.add('is-pending')
          later(pane, () => step.classList.remove('is-pending'), 450)
        }
      }, start)
      delay += step.matches('.chat-msg-user') ? Array.from(originals.get(step)).length * 12 + 350 : 700
    })
  }
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35 &&
            entry.target.classList.contains('is-animating') &&
            !entry.target.closest('[data-chat-scenario]')?.hidden) play(entry.target)
      })
    }, {threshold: 0.35})
  }
  panes.forEach((pane) => pane.querySelectorAll('.chat-msg-user').forEach((step) => originals.set(step, step.textContent)))
  const select = (index, focus = false) => {
    selected = index
    panes.forEach(reset)
    tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index))
      tab.tabIndex = i === index ? 0 : -1
      panels[i].hidden = i !== index
      panels[i].setAttribute('role', 'tabpanel')
      panels[i].setAttribute('aria-labelledby', tab.id)
      panels[i].tabIndex = 0
    })
    if (focus) tabs[index].focus()
    if (!motion.matches && observer) {
      (panels[index] || demo).querySelectorAll('[data-chat-pane]').forEach((pane) => {
        pane.classList.add('is-animating')
        observer.observe(pane)
      })
    }
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(index))
    tab.addEventListener('keydown', (event) => {
      const next = {ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1}[event.key]
      if (next !== undefined) { event.preventDefault(); select(next, true) }
    })
  })
  motion.addEventListener('change', () => select(selected))
  demo.querySelector('.chat-demo-controls').hidden = tabs.length < 2
  demo.classList.add('is-enhanced')
  select(0)
})
